<template>
  <base-row v-bind="$props">
    <td>
      {{ item.name }}
    </td>
    <td>
      {{ item.quantity_total }}
    </td>
    <td>
      {{ item.quantity_on_hand }}
    </td>
    <td>
      {{ item.quantity_available }}
    </td>
    <td>
      <a
        href="#"
        @click.prevent="toggleAvailability()"
        class="font-sm flex"
        :class="{ 'text-blue-600': item.has_ecommerce, 'text-red-400': !item.has_ecommerce }"
      >
        <CheckCircleIcon
          v-if="item.has_ecommerce"
          class="h-5 w-5 mr-1 text-blue-600"
          aria-hidden="true"
        />
        <MinusCircleIcon
          v-if="!item.has_ecommerce"
          class="h-5 w-5 mr-1 text-red-400"
          aria-hidden="true"
        />
        <span v-if="item.has_ecommerce">Available</span>
        <span v-if="!item.has_ecommerce">Not Available</span>
      </a>
    </td>
    <!--        <td>-->
    <!--            {{ item.quantity_transfers_pending }}-->
    <!--        </td>-->
    <!--        <td>-->
    <!--            {{ item.quantity_transfers_in_transit }}-->
    <!--        </td>-->
  </base-row>
</template>

<script>
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import { CheckCircleIcon, MinusCircleIcon } from '@heroicons/vue/solid'

export default {
  components: {
    'base-row': TableRow,
    CheckCircleIcon,
    MinusCircleIcon
  },

  mixins: [RowProps],

  props: {
    /**
     * A function that we can use to generate the URL to view a package. Returns a string that is a valid URL
     */
    showRoute: {
      type: Function,
      default: (item) => null
    }
  },

  computed: {
    /**
     * Returns the URL we can use to view a package
     */
    locationShowRoute() {
      return this.showRoute(this.item)
    },

    /**
     * Returns true if this package has a valid URL to view a package
     * @returns {boolean}
     */
    hasRoute() {
      return this.locationShowRoute !== null
    }
  },

  methods: {
    toggleAvailability() {
      this.$emit('update', {
        ...this.item,
        has_ecommerce: !this.item.has_ecommerce
      })
    }
  }
}
</script>
